import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_NEW_COACHES} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewFrontlineCoachesContent} from './NewFrontlineCoachesContent';
import reportPayload from './reportPayload';

export const NewFrontlineCoachesReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'New Frontline Coaches')}
      description={tt(
        'description',
        "New Coaches you've sponsored this month.",
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewFrontlineCoachesContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newFrontlineCoaches'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_NEW_COACHES,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts(
          'reportRecordTitle.newFrontLine',
          'New Frontline Coaches',
        ),
    },
  }),
)(NewFrontlineCoachesReport);
